// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2FP7A","label":"SetPasswdForm_label__1o5Tm"};